<template>
  <div class="input-group">
    <div class="row">
      <div class="col-md-8 col-sm-12 order-md-1 order-0">
        <div class="input-group mb-1">
          <input name="name" type="text"
                 class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                 style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                 :placeholder="__('how-to-sell.name')" aria-label="Name" aria-describedby="basic-addon1"
                 v-model="register.name">
        </div>
        <div class="row">
          <div class="col-12 col-lg-6 pr-lg-1 input-group mb-1">
            <input name="email" type="email"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.email')" aria-label="Email" aria-describedby="basic-addon1"
                   v-model="register.email">
          </div>
          <div class="col-12 col-lg-6 pl-lg-0 input-group mb-1">
            <input type="numeric" name="phone"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.tel')" aria-label="Phone" aria-describedby="basic-addon1"
                   v-model="register.phone">
          </div>
        </div>
        <div class="row" v-if="locale() != 'ro'">
          <div class="col-12 col-lg-6 pr-lg-1 input-group mb-1">
            <input name="address" type="text"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.address')" aria-label="Username" aria-describedby="basic-addon1"
                   v-model="register.address">
          </div>
          <div class="col-12 col-lg-6 pl-lg-1 input-group mb-1">
            <div class=" dropdown inline-block relative" style="float: right; z-index:99999;width: 100%;">
              <input type="text"
                     class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                     style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                     :placeholder="__('how-to-sell.selectTeam')" v-model="countrySelect" aria-describedby="basic-addon1"
                     disabled>
              <ul class="dropdown-menu absolute hidden text-gray-700 pt-1"
                  style="box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 8px !important;">

                <button
                    style=" padding: 5px;font-size: 12px; margin: 5px;background-color: transparent;background-image: none;border: none"
                    v-for="entry in languages" :key="entry.title" @click="setCountry(entry)">
                  <div class="flex flex-row ">
                    <i class="sl-flag center-vertically" v-bind:class="'flag-' + entry.language"></i>
                    <p class="pl-2"> {{ entry.title }} </p>
                  </div>
                </button>
              </ul>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 order-md-1 order-0">
            <textarea name="referrals" rows="2" type="text"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.referrals')" aria-label="Username" aria-describedby="basic-addon1"
                   v-model="register.referrals"></textarea>
          </div>

        </div>
        <div v-else>
          <div class="input-group mb-1">
            <input name="address" type="text"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.address')" aria-label="Username" aria-describedby="basic-addon1"
                   v-model="register.address">
          </div>
          <div class="input-group mb-1">
            <textarea name="referrals" rows="2" type="text"
                   class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder bg-white"
                   style="border: 1px solid #dee2e6 !important; background:#E8E8E8 !important;"
                   :placeholder="__('how-to-sell.referrals')" aria-label="Username" aria-describedby="basic-addon1"
                      v-model="register.referrals"></textarea>
          </div>
        </div>
        <div class="input-group mb-1 mt-3 d-none d-md-flex">
          <div class="col-md-8 px-0">
            <div class="row">
              <div class="col-12">
                <input name="privacy1" type="checkbox" class="" placeholder="privacy1" aria-label="privacy1"
                       aria-describedby="basic-addon1" style="background:#E8E8E8 !important;float:left;"
                       v-model="register.privacy1">
                <span class="policy_agreement">
                  {{ __('gdpr-notice') }}<a href="/Nota_de_informare_Artmark.pdf">{{ __('gdpr-notice-link') }}</a>
                </span>
              </div>

            </div>
          </div>
          <div class="col-md-4 px-0">
            <div class="d-flex justify-content-end">
              <button class="action_box action_box_full_width_mobile cursor-pointer" v-on:click="send_form">
                {{ __('how-to-sell.send') }} <img src="/assets/img/cms/right-arrow-angle.svg"
                                                  class="action_box_decoration"/></button>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div v-if="!$isMobile()" class="iziToast-wrapper-sell iziToast-responsive-container"></div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12 order-md-0 order-1">
        <textarea name="message" rows="10" cols="100" :placeholder="__('how-to-sell.message')" class="pt-2"
                  style="width:100%; padding-left: 0.78rem;" v-model="register.message"></textarea> <br/>

        <!-- Upload documents block-->
        <div class="d-flex mt-4 border" style="border: 1px dashed lightgray;">
          <div class="md:w-100 center-vertically py-6 m-auto text-center">
            <label for="upload" class="cursor-pointer my-2">
              <span aria-hidden="true"
                    class="upload-disclaimer text-uppercase h7">{{ __('how-to-sell.add_documents') }}</span>
              <input type="file" multiple="multiple" ref="upload" @change="handleFileChanges" :accept="accept"
                     id="upload" style="display:none">
              <p class="text-xs text-grey-darker small m-0">{{ __('how-to-sell.files') }}
              </p>
            </label>
          </div>
        </div>
        <div class="items-left mb-6 mt-3" v-if="register.files.length">
          <div class="file-upload-container text-xs row" v-for="(file, index) in register.files" :key="index">
            <span class="text-left float-left upload-file-appraisal col-10"><strong
                class="pr-3">{{ __('how-to-sell.file') }} {{ index + 1 }}:</strong> {{ file.name }}</span>
            <!-- <span class="text-xs">{{ file.size | formatSize }}</span> -->
            <button
                class="vertical-super float-left border-white ml-1 remove-file bg-dark text-white h8 h-100 rounded-cirlcle"
                type="button" @click.prevent="register.files.splice(index, 1)" style="width:20px;">x
            </button>
            <br/>
          </div>
        </div>
        <!-- End upload documents block !-->
      </div>
      <div class="col-12 order-2 input-group mb-1 mt-3 d-md-none">
        <div class="col-12 col-md-10" style="padding-left:0px;">
          <input name="privacy1" type="checkbox" class="" placeholder="privacy1" aria-label="privacy1"
                 aria-describedby="basic-addon1" style="background:#E8E8E8 !important;float:left;"
                 v-model="register.privacy1">
          <span class="policy_agreement">
            {{ __('gdpr-notice') }}<a href="/Nota_de_informare_Artmark.pdf">{{ __('gdpr-notice-link') }}</a>
          </span>
        </div>
        <div class="col-12 col-md-2 mt-3 px-0">
          <div v-if="$isMobile()" class="iziToast-wrapper-sell"></div>
        </div>
        <div class="col-12 col-md-2 mt-3 px-0">
          <button class="action_box action_box_full_width_mobile cursor-pointer" v-on:click="send_form">
            {{ __('how-to-sell.send') }} <img src="/assets/img/cms/right-arrow-angle.svg"
                                              class="action_box_decoration"/></button>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 col-12 pl-0 pr-0 mt-3">

      <div id="sell_alert_div" class="col-md-12 card mb-3 rounded-0 p-3 d-inline" v-if="hasMessage"
           v-bind:class="{'text-danger border-danger':hasError, 'text-success border-success':!hasError }"
           v-text="appraisal_message"></div>
    </div>

  </div>
</template>
<style>
.dropdown:hover .dropdown-menu {
  display: block;
  position: absolute;
  background: white;

}
</style>
<script>


export default {
  name: "HowToSell",
  data: function () {
    return {
      countrySelect: null,
      country: null,
      accept: "image/*,application/pdf",
      register: {
        email: null,
        phone: null,
        name: null,
        address: null,
        referrals: null,
        privacy1: false,
        privacy2: false,
        message: null,
        files: []
      },
      hasMessage: false,
      hasError: false,
      appraisal_message: '',
      languages: [
        {
          flag: 'bg', language: 'bg', title: 'Bulgaria'
        },
        {
          flag: 'ro', language: 'ro', title: 'România'
        },
        {
          flag: 'hr', language: 'hr', title: 'Croatia'
        }
      ]
    }
  },
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    locale() {
      return window.location.pathname.split('/')[1];
    },
    setCountry(country) {
      this.country = country.language;
      this.countrySelect = country.title;
    },
    resetFileInput() {
      const input = this.$refs.upload;
      input.type = 'text';
      input.type = 'file';
    },
    handleFileChanges(e) {
      var files = e.target.files || e.dataTransfer.files;
      var totalSize = 0;
      if (!files.length) return;
      for (var i = files.length - 1; i >= 0; i--) {
        let duplicate = false;
        this.register.files.forEach(function (element) {
          if (element.name === files[i].name) {
            duplicate = true;
          }
        });
        if (!duplicate) {
          if ((files[i].size / 1024 / 1024) < 15) {
            this.register.files.push(files[i]);
            totalSize = totalSize + files[i].size;
            if ((totalSize / 1024 / 1024) > 15) {
              window.showToast(this.__('how-to-sell.file-limit-exceeded'), 'error', null, '.iziToast-wrapper-sell')
            }
          } else {
            window.showToast(this.__('how-to-sell.file-limit-exceeded'), 'error', null, '.iziToast-wrapper-sell')
          }
        }
      }
      this.resetFileInput();
    },
    send_form: function () {
      let data = new FormData();
      var totalSize = 0;
      if (this.register.email) data.append('email', this.register.email);
      if (this.register.phone) data.append('phone', this.register.phone);
      if (this.register.name) data.append('name', this.register.name);
      if (this.register.address) data.append('address', this.register.address);
      if (this.register.referrals) data.append('referrals', this.register.referrals);
      if (this.register.privacy1) data.append('privacy1', this.register.privacy1);
      if (this.register.privacy2) data.append('privacy2', this.register.privacy2);
      if (this.register.message) data.append('message', this.register.message);
      data.append('locale', this.locale());
      data.append('country', this.country);
      for (var i = 0; i < this.register.files.length; i++) {
        data.append("files[" + i + "]", this.register.files[i])
        totalSize = totalSize + this.register.files[i].size;
      }
      if ((totalSize / 1024 / 1024) > 15) {
        window.showToast(this.__('how-to-sell.file-limit-exceeded'), 'error', null, '.iziToast-wrapper-sell')
      }
      // for (var pair of data.entries())
      // {
      //  console.log(pair[0]+ ', '+ pair[1]);
      // }
      axios.post('/api/appraisal-submit', data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
        window.showToast(response.data.message, 'success', null, '.iziToast-wrapper-sell')
      }).catch((error) => {
        console.log(error)
        window.showToast(error.message, 'error', null, '.iziToast-wrapper-sell')
      });
    }
  },
}
</script>
